import axios from 'axios';

const remote = axios.create({});

if (window.appReactHeaders) {
  Object.keys(window.appReactHeaders).forEach((k) => {
    remote.defaults.headers.common[k] = window.appReactHeaders[k];
  });
}

export default remote;
